// plugins/myPlugins.js
import fieldValidator from "@helpers/validators";

export default {
  install: (Vue, options) => {
    // add an instance method
    Vue.prototype.$fieldValidator = fieldValidator;
  }
}